import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { IObject } from '../../../../../../type_definitions/datatypes';
import { IExtraFieldConfigurationObject } from '../../../../formly/ga-formly.service';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'custom-rate-input',
  template: `
    <div class="custom-rate">
      <table class="table">
        <tr>
          <td>1 {{currency}}</td>
          <td>=</td>
          <td class="input-column">
            <formly [fields]="fields" [form]="form" [model]="model"></formly>
          </td>
          <td>{{invoiceCurrency}}</td>
          <td class="spot-rate-button"><button class="btn-link" (click)="loadSpotRate.emit()">Spot Rate: {{spotRate}}</button>
          </td>
        </tr>
        <tr>
          <td>1 {{invoiceCurrency}}</td>
          <td>=</td>
          <td class="calculated-rate">{{calculatedRate}}</td>
          <td>{{currency}}</td>
        </tr>
      </table>
    </div>
  `
})
export class CustomRateInputComponent implements OnInit, OnChanges {
  @Input() public currency: string;
  @Input() public invoiceCurrency: string;
  @Input() public calculatedRate: string;
  @Input() public model: IObject;
  @Input() public fields: IExtraFieldConfigurationObject[];
  @Input() public spotRate: number;

  @Output() public loadSpotRate: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onModelChange: EventEmitter<IObject> = new EventEmitter<IObject>();
  public form: UntypedFormGroup = new UntypedFormGroup({});

  constructor() {
    /**/
  }

  public ngOnInit(): void {
    this.listen();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // this being triggered by changing model input in parent component
    if (changes.model) {
      this.form.patchValue(changes.model.currentValue);
    }

    if (changes.spotRate) {
      this.spotRate = changes.spotRate.currentValue;
    }

    if (changes.currency) {
      this.currency = changes.currency.currentValue;
    }

    if (changes.invoiceCurrency) {
      this.invoiceCurrency = changes.invoiceCurrency.currentValue;
    }

    if (changes.calculatedRate) {
      this.calculatedRate = changes.calculatedRate.currentValue;
    }
  }

  private listen(): void {
    this.form.valueChanges.subscribe(model => this.onModelChange.emit(model));
  }
}